import { useConvertWastrView } from "./context/ConvertWastrViewContext";
import { Depositing } from "./Depositing";
import { NoApproval } from "./NoApproval";
import { Withdrawing } from "./Withdrawing";

type ConvertWastrProps = {
  onCancel: VoidFunction;
  onSubmit: VoidFunction;
};

export const ConvertWastr: React.FC<ConvertWastrProps> = ({ onCancel, onSubmit }) => {
  const { view } = useConvertWastrView();

  switch (view) {
    case "DEPOSITING":
      return <Depositing onCancel={onCancel} onSubmit={onSubmit} />;

    case "WITHDRAWING":
      return <Withdrawing onCancel={onCancel} onSubmit={onSubmit} />;

    case "NO_APPROVAL":
      return <NoApproval />;
  }
};
